import React from "react";
import { REWARD_OFFERING } from "../../constants";
import OnboardingPage from "../../common/components/OnboardingPage";
import { getRedeemUrlWithContext } from "../../utils";

function CareParkMain() {
  const redeemUrl = getRedeemUrlWithContext(REWARD_OFFERING.carepark);

  return (
    <OnboardingPage
      redeemUrl={redeemUrl}
      rewardId={REWARD_OFFERING.carepark}
      viewType="external"
      linkDisplayName="Care Park app"
    />
  );
}

export default CareParkMain;